import React, { RefObject } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Card, UploadButton } from "../../index.style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "iebt-zing-storybook";

type TrackInfoFormCardProps = {
  draft: {
    title: string;
    description: string;
    imageFile?: File | null;
    imageUrl?: string | null;
  };
  errors: { title?: string; description?: string; imageFile?: string };
  fileRef: RefObject<HTMLInputElement>;
  onChange: (field: "title" | "description", value: string) => void;
  handleFile: (f?: File) => void;
  triggerUpload: () => void;
  removeImage: () => void;
};

const RECOMMENDED_W = 784;
const RECOMMENDED_H = 240;

export const TrackInfoFormCard: React.FC<TrackInfoFormCardProps> = ({
  draft,
  errors,
  fileRef,
  onChange,
  handleFile,
  triggerUpload,
  removeImage,
}) => {
  return (
    <Card className="mt-4">
      <Card.Body>
        <Row className="gap-0 p-2">
          <Col xs={12}>
            <Form.Label className="fw-semibold">
              Nome da trilha<span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              value={draft.title}
              onChange={(e) => onChange("title", e.target.value)}
              placeholder="Digite o nome da trilha"
              isInvalid={!!errors.title}
            />
            <Form.Control.Feedback type="invalid">
              {errors.title}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12}>
            <Input
              id="description"
              type="texteditor"
              code="texteditor"
              label="Descrição"
              value={draft.description}
              isRequired
              className={errors.description ? 'is-invalid' : ''}
              onChange={(event) => {
                const element = event.target as HTMLTextAreaElement
                onChange('description', element.value)
              }}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Col>

          <Col xs={12}>
            <Form.Label className="fw-semibold">
              Imagem de divulgação da trilha{" "}
              <span className="text-danger">*</span>
            </Form.Label>
            <div className="text-muted small mb-2">
              Dimensão recomendada: {RECOMMENDED_W} × {RECOMMENDED_H}px
            </div>

            <div className="d-flex align-items-center gap-3">
              <input
                ref={fileRef}
                type="file"
                accept="image/*"
                hidden
                onChange={(e) => handleFile(e.target.files?.[0])}
              />
              
              {!(draft.imageFile || draft.imageUrl) && (
                <UploadButton onClick={triggerUpload}>
                  <FontAwesomeIcon
                    icon={["fas", "cloud-arrow-up"]}
                    style={{ marginRight: 8 }}
                  />
                  Adicionar imagem
                </UploadButton>
              )}

              {draft.imageUrl && (
                <div className="position-relative">
                  <img
                    src={draft.imageUrl}
                    alt="preview"
                    style={{
                      width: 240,
                      height: 74,
                      objectFit: "cover",
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                    }}
                  />
                  <button
                    type="button"
                    onClick={removeImage}
                    style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '-8px',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      backgroundColor: '#0d6efd',
                      border: '2px solid white',
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                    title="Remover imagem"
                  >
                    ×
                  </button>
                </div>
              )}
              {draft.imageFile && !draft.imageUrl && (
                <div className="position-relative d-inline-block">
                  <div className="text-success small d-flex align-items-center">
                    <span className="me-2">✓</span>
                    <span>Imagem selecionada: {draft.imageFile.name}</span>
                  </div>
                  <button
                    type="button"
                    onClick={removeImage}
                    style={{
                      position: 'absolute',
                      top: '-8px',
                      right: '-8px',
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      backgroundColor: '#0d6efd',
                      border: '2px solid white',
                      color: 'white',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}
                    title="Remover imagem"
                  >
                    ×
                  </button>
                </div>
              )}
            </div>

            {errors.imageFile && (
              <div className="invalid-feedback d-block">{errors.imageFile}</div>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
